import { Navigate, Outlet } from "react-router-dom";
export default function RoleRoute({ roles }) {
  // ✅ read role from auth object in localStorage
  const auth = JSON.parse(localStorage.getItem("auth") || "{}");
  const role = auth.role;
  const isLoggedIn = !!auth.token; // true if logged in
  console.log("User role:", role);

  // Not logged in → go to login
  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  // Logged in but role not allowed → redirect to default allowed page
  if (!roles.includes(role)) {
    return <Navigate to="/pos" replace />;
  }

  // Allowed → render nested routes
  return <Outlet />;
}
